const Transitions = {
  default: "0.3s ease-in-out",
  cubicBezier: "cubic-bezier(0.65, 0.05, 0.36, 1)",
};

export default Transitions;
